import * as TopsFlopsActions from '../actions/tops-flops';
import { TopFlop } from '../../../../models/tops-flops/top-flop';

export class State {
	[s: string]: TopFlop;
}

export const InitialState: State = {};

export function reducer(state: State = InitialState, action: TopsFlopsActions.All): State {
	switch (action.type) {
		case TopsFlopsActions.ADD_TOP_FLOP_SUCCESS:
			return {...state, [action.payload.BT01]: action.payload};

		case TopsFlopsActions.UPDATE_TOP_FLOP_SUCCESS:
			return {...state, [action.payload.BT01]: action.payload};

		case TopsFlopsActions.REMOVE_TOP_FLOP_SUCCESS:
			const newState = {};

			Object.keys(state).forEach(bt01 => {
				if (state[bt01]._id !== action.payload._id) {
					newState[bt01] = state[bt01];
				}
			});

			return newState;

		case TopsFlopsActions.LOAD_TOP_FLOP_SUCCESS:
			const loadState = {...state};

			action.payload.forEach(tf => {
				loadState[tf.BT01] = tf;
			});

			return loadState;

		case TopsFlopsActions.RESET_TOPS_FLOPS:
			return {};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/app/xena/core/shared/components/tops-flops/state-management/reducers/tops-flops.ts